import { default as routes } from './model/routes';
import { default as menuItems } from './menu';
import * as layout from './views/layout';

export default { ...routes, menuItems, layout };
